
    import './styles.scoped.css';
    export default {
  "option": "awsui_option_1p2cx_1il7k_13",
  "disabled": "awsui_disabled_1p2cx_1il7k_50",
  "parent": "awsui_parent_1p2cx_1il7k_53",
  "highlighted": "awsui_highlighted_1p2cx_1il7k_56",
  "content": "awsui_content_1p2cx_1il7k_60",
  "label-content": "awsui_label-content_1p2cx_1il7k_67",
  "label": "awsui_label_1p2cx_1il7k_67",
  "tag": "awsui_tag_1p2cx_1il7k_74",
  "label-tag": "awsui_label-tag_1p2cx_1il7k_75",
  "label-prefix": "awsui_label-prefix_1p2cx_1il7k_85",
  "trigger-variant": "awsui_trigger-variant_1p2cx_1il7k_98",
  "tags": "awsui_tags_1p2cx_1il7k_112",
  "description": "awsui_description_1p2cx_1il7k_113",
  "selected": "awsui_selected_1p2cx_1il7k_124",
  "icon": "awsui_icon_1p2cx_1il7k_138",
  "filtering-match-highlight": "awsui_filtering-match-highlight_1p2cx_1il7k_145",
  "custom-content": "awsui_custom-content_1p2cx_1il7k_166"
};
  